import React from "react";
import Select from "react-select";

export const productLabel = (product) => {
  const translations = product?.product_translations || [];
  const en = translations.find((t) => t.local === "en")?.nameProduct;
  const ar = translations.find((t) => t.local === "ar")?.nameProduct;
  return [en, ar].filter(Boolean).join(" — ") || `#${product?.id}`;
};

// Searchable multi-select of the products linked to a recipe. `value` is the
// list of selected product ids.
function LinkedProductsSelect({ products, value, onChange }) {
  const options = (products || []).map((product) => ({
    value: product.id,
    label: productLabel(product),
  }));
  const selected = (Array.isArray(value) ? value : [])
    .map((id) => options.find((option) => option.value === id))
    .filter(Boolean);

  return (
    <Select
      isMulti
      options={options}
      value={selected}
      onChange={(chosen) =>
        onChange((chosen || []).map((option) => option.value))
      }
      placeholder="Search products by English or Arabic name..."
      noOptionsMessage={() => "No products found"}
    />
  );
}

export default LinkedProductsSelect;
